import { useEffect } from 'react';
import { Alert, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Link } from 'react-router-dom';
import { useConfig } from '@/contexts/AppConfigContext';
import { EmailIdentity } from '@/types';

export default function EmailIdentitySelect({
  value,
  onChange,
}: {
  value: EmailIdentity | null;
  onChange: (value: EmailIdentity) => void;
}) {
  const { emailIdentities } = useConfig();

  useEffect(() => {
    if (emailIdentities.length > 0 && !value) {
      onChange(emailIdentities[0].id);
    }
  }, [value, emailIdentities.length]);

  if (emailIdentities.length <= 1) {
    return (
      <Alert severity="info">
        This feature supports sending emails directly from your Gmail. You can configure it{' '}
        <Link to="/gmail-setup">here</Link>.
      </Alert>
    );
  }

  return (
    <FormControl fullWidth size="small">
      <InputLabel>From</InputLabel>
      <Select
        variant="outlined"
        label="From"
        value={value}
        onChange={(e) => onChange(e.target.value as EmailIdentity)}
      >
        {emailIdentities.map((identity) => (
          <MenuItem key={identity.id} value={identity.id}>
            {`${identity.name} <${identity.address}>`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
